import { useEffect, useRef, useState } from 'react'

import { Button, Flex, TextField } from 'components'

interface NumberOfParentsProps {
  initialValue: number
  isLoading: boolean
  onChange: (value: number) => void
}

let isFetching = false

const MAX_NUMBER_OF_PARENTS = 4

const NumberOfParents = ({ initialValue, isLoading, onChange }: NumberOfParentsProps) => {
  const [value, setValue] = useState(initialValue)
  const ref = useRef(null)

  useEffect(() => {
    setValue(initialValue)

    if (!isFetching) {
      ref.current.value = initialValue
    }
  }, [initialValue])

  const handleChange = async (newValue: number) => {
    isFetching = true
    ref.current.value = newValue
    await onChange(newValue)
    isFetching = false
  }

  const handleBlur = (e) => {
    const newValue = +e.target.value

    if (1 > newValue) {
      handleChange(1)
    } else if (MAX_NUMBER_OF_PARENTS < newValue) {
      handleChange(MAX_NUMBER_OF_PARENTS)
    } else {
      handleChange(newValue)
    }
  }

  return (
    <Flex gap="5px">
      <Button
        disabled={isLoading || 1 >= value}
        icon="minus"
        negativeMargins
        onClick={() => !isLoading && handleChange(value - 1)}
      />
      <TextField disabled={isLoading} placeholder="2" ref={ref} type="number" width={100} onBlur={handleBlur} />
      <Button
        disabled={isLoading || MAX_NUMBER_OF_PARENTS <= value}
        icon="plus"
        negativeMargins
        onClick={() => !isLoading && handleChange(value + 1)}
      />
    </Flex>
  )
}

export default NumberOfParents
